<template>
  <div class="app-wrapper">
    <el-aside
      class="menu"
      :style="{ width: isCollapse == true ? '80px' : '240px' }"
    >
      <sidebarNav />
    </el-aside>

    <mainContent
      class="content"
      :style="{
        marginLeft: isCollapse == true ? '80px' : '240px',
        width: isCollapse == true ? 'calc(100% - 80px)' : 'calc(100% - 240px)',
      }"
    />
  </div>
</template>

<script>
import sidebarNav from "./sidebar";
import mainContent from "./component/main-content/index";
import { mapState } from "vuex";

export default {
  components: {
    sidebarNav,
    mainContent,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("premissions", ["sidebarMenu", "currentMenu", "isCollapse"]),
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.app-wrapper {
  display: flex;

  /deep/ .el-aside {
    transition: width 0.5s;
    -webkit-transition: width 0.5s;
    -moz-transition: width 0.5s;
    -webkit-transition: width 0.5s;
    -o-transition: width 0.5s;
  }

  .menu {
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    background: #000;
    z-index: 99;
  }
}
</style>